<template>
    <router-view data-slot="targetContent"></router-view>
</template>
<script>
export default {
    name: 'EmptyLayout',
}
</script>
